import React from 'react';

import {
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  ChipField,
  usePermissions,
} from 'react-admin';

import LinkField from '../../../layout/LinkField';
import NoResults from '../../../layout/NoResults';
import StatusField from '../../../../customFields/StatusField';
import ReferenceEntityField from '../../../../customFields/ReferenceEntityField';
import { boldDataGridStyle } from '../../../../constants/style/datagridStyles';
import EntityDisplayNameField from '../../../../customFields/EntityDisplayNameField';
import actions, { Actions } from '../../../../constants/actions';
import hasAccess from '../../../../utilities/hasAccess';

const CarPurchase = (
  {
    children,
  }: {
    children?: React.ReactNode;
  },
) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid sx={boldDataGridStyle} bulkActionButtons={false} empty={<NoResults variant="h6" />}>
      <LinkField sortable={false} source="id" label="ID" />
      <TextField sortable={false} source="customId" label="Custom ID" />
      <DateField sortable source="createdAt" showTime />
      <StatusField sortable={false} source="recommendation" />
      {hasAccess(permissions, actions.PROCESS_GET) && (
        <ReferenceField sortable reference="processes" source="process">
          <ChipField source="name" />
        </ReferenceField>
      )}
      <DateField sortable={false} source="extraInformation.date" showTime />
      <TextField source="extraInformation.amount" label="Amount" />
      <TextField sortable={false} source="extraInformation.currency" label="Currency" />
      <ReferenceEntityField sortable={false} source="extraInformation.car" label="Car">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.buyer" label="Buyer">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.seller" label="Seller">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.guarantor" label="Guarantor">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      {children}
    </Datagrid>
  );
};

export default CarPurchase;
